import React, { FunctionComponent, useEffect, useState } from 'react';
import '@justgiving/loading/src/Loading.scss';

import { PageSection } from '../..';
import AuctionLotsListSkeleton from './AuctionLotsListSkeleton';
import { AuctionLot } from '../../../../types/__generated__';
import styles from './AuctionLotsList.scss';
import { useModalToggle } from '../../../hooks/useModalToggle';
import Modal from '../../Modal/Modal';
import { AuctionLotPanel } from '../AuctionLotPanel/AuctionLotPanel';
import AuctionBiddingModal, {
  WinningBid,
} from '../AuctionBiddingModal/AuctionBiddingModal';

interface AuctionLotsListProps {
  lots?: AuctionLot[];
}

const AuctionLotsList: FunctionComponent<AuctionLotsListProps> = ({ lots }) => {
  const { isOpen: isModalOpen, setOpen: setModalOpen } = useModalToggle();
  const [selectedLot, setSelectedLot] = useState<AuctionLot | undefined>(
    undefined,
  );
  const [userWinningBids, setUserWinningBids] = useState<WinningBid[]>([]);
  // console.log(userWinningBids);

  const updateUserWinningBids = (bid: WinningBid) => {
    // console.log(bid);
    const index = userWinningBids.findIndex(lot => {
      return lot.lotId === bid.lotId;
    });
    if (index > -1) {
      // console.log('User was previously a top bidder for this lot');
      let newUserWinningBids = JSON.parse(JSON.stringify(userWinningBids));
      newUserWinningBids.splice(index, 1, bid);
      // console.log(newUserWinningBids);
      setUserWinningBids(newUserWinningBids);
    } else {
      // console.log('First time highest bid on this lot');
      setUserWinningBids([...userWinningBids, bid]);
    }
  };

  useEffect(() => {
    if (lots && selectedLot) {
      const updatedLot = lots.find(
        lot => lot.legacyId === selectedLot.legacyId,
      );
      if (updatedLot && updatedLot.highestBid !== selectedLot.highestBid) {
        // console.log('updating lot with fresh data!!!');
        setSelectedLot(updatedLot);
      }
    }
  }, [lots, selectedLot]);

  if (!lots) {
    return <AuctionLotsListSkeleton animated displayRefreshButton={false} />;
  }

  if (lots.length === 0) {
    return <p>'No Lots in this Auction yet!'</p>;
  }

  const handleClick = (lot: AuctionLot) => {
    setSelectedLot(lot);
    setModalOpen(true);
  };

  return (
    <PageSection
      title={'Auction Lots'}
      count={lots.length}
      className={styles.container}
    >
      <ul data-qa="supporters-list">
        {lots.map(lot => {
          const winning =
            userWinningBids.filter(bid => {
              return (
                bid.lotId === lot.legacyId &&
                bid.bidAmount >= lot.highestBid.value
              );
            }).length > 0;

          const userHighestBid = userWinningBids.find(bid => {
            return bid.lotId === lot.legacyId;
          });

          return (
            <AuctionLotPanel
              lot={lot}
              onClick={handleClick}
              key={lot.legacyId}
              winning={winning}
              userHighestBid={userHighestBid?.bidAmount}
            />
          );
        })}
      </ul>

      {isModalOpen && selectedLot && (
        <Modal onCloseRequest={() => setModalOpen(false)}>
          <AuctionBiddingModal
            lot={selectedLot}
            onClose={() => setModalOpen(false)}
            updateUserWinningBids={updateUserWinningBids}
          />
        </Modal>
      )}
    </PageSection>
  );
};

export default AuctionLotsList;
